import Modal from "../common/Modal";
import ModalContentWithCloseButton from "../common/ModalContentWithCloseButton";
import SVGViewer from "../common/SVGViewer";
import { makeSilkscreenWhite } from "./index";
import {
  FootprintDetails,
  InspectorContainer,
  Title,
} from "./FootprintSummaryStyles";
import InfoItem from "../component-search/PartDrawer/PartDetails/InfoItem";
import React from "react";
import { Footprint } from "../../utils/hooks/footprints/models";

export default function Inspector({
  footprint,
  isOpen,
  onRequestClose,
}: {
  footprint: Footprint | null;
  isOpen: boolean;
  onRequestClose: () => void;
}) {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalContentWithCloseButton
        title={
          footprint === null
            ? "Create footprint"
            : `Footprint: ${footprint.name}`
        }
        closeModal={onRequestClose}
        fullScreen
      >
        <InspectorContainer>
          {footprint !== null && footprint.physical_info !== null && (
            <>
              <SVGViewer
                svgInput={{
                  svg: makeSilkscreenWhite(footprint.physical_info.svg),
                }}
              />
              <FootprintDetails>
                <Title>{footprint.name}</Title>
                <InfoItem
                  label={"Width"}
                  value={`${footprint.physical_info.width.toLocaleString(
                    undefined,
                    {
                      maximumFractionDigits: 4,
                    },
                  )} ${footprint.physical_info.unit}`}
                />
                <InfoItem
                  label={"Height"}
                  value={`${footprint.physical_info.height.toLocaleString(
                    undefined,
                    {
                      maximumFractionDigits: 4,
                    },
                  )} ${footprint.physical_info.unit}`}
                />
                {footprint.is_flashpcb_footprint && (
                  <InfoItem
                    label={"Source"}
                    value={"FlashPCB Component Library"}
                  />
                )}
              </FootprintDetails>
            </>
          )}
        </InspectorContainer>
      </ModalContentWithCloseButton>
    </Modal>
  );
}
